import {
  SALESPERSON_DETAILS_FAIL,
  SALESPERSON_DETAILS_REQUEST,
  SALESPERSON_DETAILS_RESET,
  SALESPERSON_DETAILS_SUCCESS,
  SALESPERSON_UPDATE_FAIL,
  SALESPERSON_UPDATE_REQUEST,
  SALESPERSON_UPDATE_RESET,
  SALESPERSON_UPDATE_SUCCESS
} from '@/constants/salespersonConstants'

/**
 * Reducer for salesperson details
 * @param {Object} state - Current state
 * @param {Object} action - Redux action
 * @returns {Object} New state
 */
export const salespersonDetailsReducer = (state = { loading: false, salesperson: null, error: null }, action) => {
  switch (action.type) {
    case SALESPERSON_DETAILS_REQUEST:
      return { ...state, loading: true, error: null }

    case SALESPERSON_DETAILS_SUCCESS:
      return {
        loading: false,
        salesperson: action.payload,
        error: null
      }

    case SALESPERSON_DETAILS_FAIL:
      return {
        loading: false,
        salesperson: null,
        error: action.payload
      }

    case SALESPERSON_DETAILS_RESET:
      return {
        loading: false,
        salesperson: null,
        error: null
      }

    default:
      return state
  }
}

/**
 * Reducer for salesperson update
 * @param {Object} state - Current state
 * @param {Object} action - Redux action
 * @returns {Object} New state
 */
export const salespersonUpdateReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case SALESPERSON_UPDATE_REQUEST:
      return { loading: true, success: false, error: null }

    case SALESPERSON_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        salesperson: action.payload,
        error: null
      }

    case SALESPERSON_UPDATE_FAIL:
      return {
        loading: false,
        success: false,
        error: action.payload
      }

    case SALESPERSON_UPDATE_RESET:
      return {
        loading: false,
        success: false,
        error: null
      }

    default:
      return state
  }
}
